import Drill from "@drillflo/drillcore/lib/Drill";
import View from "@drillflo/drillcore/lib/2d/View";
import { toast } from "react-hot-toast";

export const useKeyboard = (
  drill: Drill,
  view: View,
  playbackState,
  setPlaybackState: (state: PlaybackState) => void,
  handlePlayDrill: () => void,
  handleStopDrill: () => void,
  handlePageChange: (page: number) => void,
  handleCountChange: (count: number) => void,
  setFieldEditorData: (data: any) => void,
  fieldEditorData: any,
  handleNudgeRight: () => void,
  handleNudgeLeft: () => void,
  handleNudgeUp: () => void,
  handleNudgeDown: () => void
) => {
  const handleKeyDown = (key: string) => {
    if (!drill || !view) {
      return;
    }

    // Make sure the user is focusing on the canvas and not an input field
    const activeElement = document.activeElement;
    if (
      activeElement &&
      (activeElement.tagName === "INPUT" ||
        activeElement.tagName === "TEXTAREA" ||
        (activeElement as HTMLElement).isContentEditable)
    ) {
      return;
    }

    if (fieldEditorData.showDeletePerformersModal) {
      if (key === "Escape") {
        setFieldEditorData({
          ...fieldEditorData,
          showDeletePerformersModal: false,
        });
      }
      return;
    }

    if (key === " ") {
      if (playbackState.isPlaying) {
        handleStopDrill();
      } else {
        handlePlayDrill();
      }
    }
    if (key === "-") {
      view.updateDrillZoom(0.9);
    }
    if (key === "+" || key === "=") {
      view.updateDrillZoom(1.1);
    }

    if (key === "[") {
      handlePageChange(playbackState.currentPage - 1);
    }
    if (key === "]") {
      handlePageChange(playbackState.currentPage + 1);
    }
    if (key === "ArrowRight") {
      handleNudgeRight();
    }
    if (key === "ArrowLeft") {
      handleNudgeLeft();
    }
    if (key === "ArrowUp") {
      handleNudgeUp();
    }
    if (key === "ArrowDown") {
      handleNudgeDown();
    }

    if (key === "Delete" || key === "Backspace") {
      if (
        drill.engine?.selectedPerformers &&
        drill.engine.selectedPerformers.length > 0
      ) {
        setFieldEditorData({
          ...fieldEditorData,
          showDeletePerformersModal: true,
        });
      }
      return;
    }

    switch (key) {
      case "1":
        setFieldEditorData({ ...fieldEditorData, editMode: "PAN" });
        break;
      case "2":
        setFieldEditorData({ ...fieldEditorData, editMode: "SELECT_AND_MOVE" });
        break;
      case "3":
        if (drill.engine?.selectedPerformers.length === 0) {
          toast.error("No performers selected. Select performers to paint");
        } else {
          setFieldEditorData({
            ...fieldEditorData,
            editMode: "PAINT_PERFORMERS",
          });
        }
        break;
      case "4":
        setFieldEditorData({ ...fieldEditorData, editMode: "comment" });
        break;
      case "5":
        setFieldEditorData({ ...fieldEditorData, editMode: "analyze" });
      case "Enter":
        // if (isEditing) {
        //     setIsEditing(false);
        //     updateFirebaseDocument();
        // }
        break;
    }
  };

  return { handleKeyDown };
};
